<template>
  <div class="style-setting-container">
    <div class="style-setting-content">
      <div class="title flex-container">
        <div class="left">样式设计</div>
        <div class="right">
          <el-button type="text" @click="recoverSetting">恢复默认设置&nbsp;<i class="fa fa-undo"></i></el-button>
        </div>
      </div>
      <!-- 装饰只有透明度 -->
      <div v-if="data.type === 'decorate'" class="decorate-opacity flex-container">
        <div class="left title">透明度</div>
        <div class="right">
          <input-number v-model="data.decorateOpacity" :suffix="'%'"></input-number>
        </div>
      </div>
      <el-form v-else>
        <!-- 字体设置太多了，后面可以考虑将字体封装 -->
        <el-collapse v-model="activeName">
          <!-- 背景和边框 -->
          <el-collapse-item name="1" v-if="collapses.includes('1')">
            <template slot="title">背景和边框<i :class="getClass('1')"></i></template>
            <el-form-item label="背景颜色">
              <div class="form-item-right">
                <el-color-picker v-model="data.backgroundAndBorder.backgroundColor"
                                 class="custom-el-color-picker"
                                 :color-format="'rgb'"></el-color-picker>
              </div>
            </el-form-item>
            <div class="label-title flex-container line-container">
              <div class="left title">透明度</div>
              <div class="right">
                <input-number v-model="data.backgroundAndBorder.opacity" :suffix="'%'"></input-number>
              </div>
            </div>
            <div class="label-title border-style">
              <div class="title">边框</div>
              <div class="content flex-container line-container">
                <el-color-picker v-model="data.backgroundAndBorder.border.color"
                                 class="custom-el-color-picker"
                                 :color-format="'rgb'"></el-color-picker>
                <input-number v-model="data.backgroundAndBorder.border.width" :suffix="'px'"></input-number>
                <el-select class="border-select custom-el-select" v-model="data.backgroundAndBorder.border.style"
                           clearable>
                  <el-option class="border-select-option" label="实线" value="solid">
                    实线<span class="solid"></span>
                  </el-option>
                  <el-option class="border-select-option" label="虚线" value="dashed">
                    虚线<span class="dashed"></span>
                  </el-option>
                  <el-option class="border-select-option" label="点线" value="dotted">
                    点线<span class="dotted"></span>
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="border-style-img flex-container line-container">
              <div class="left title">边框样式</div>
              <div class="right">
                <el-select class="border-style-img-select custom-el-select"
                           v-model="data.backgroundAndBorder.borderStyle" clearable>
                  <el-option v-for="item in borderStyleImg"
                             :key="item.value"
                             :label="item.name"
                             :value="item.value"></el-option>
                </el-select>
              </div>
            </div>
          </el-collapse-item>
          <!-- 文本字体 -->
          <el-collapse-item name="2" v-if="collapses.includes('2')">
            <template slot="title">文本字体<i :class="getClass('2')"></i></template>
            <div class="label-title border-style">
              <div class="title">字体</div>
              <div class="content flex-container line-container">
                <el-color-picker v-model="data.textFont.font.color" class="custom-el-color-picker" :color-format="'rgb'"></el-color-picker>
                <input-number v-model="data.textFont.font.size" :suffix="'px'"></input-number>
                <el-select class="border-select custom-el-select" v-model="data.textFont.font.family" clearable>
                  <!-- 宋体、楷体、黑体、微软雅黑 -->
                  <el-option label="宋体" value="宋体"></el-option>
                  <el-option label="楷体" value="楷体"></el-option>
                  <el-option label="黑体" value="黑体"></el-option>
                  <el-option label="微软雅黑" value="微软雅黑"></el-option>
                </el-select>
              </div>
              <div class="font-style flex-container line-container">
                <div class="left title">字体样式</div>
                <div class="right">
                  <div class="font-style-select">
                    <div
                      v-for="item in fontStyleImg"
                      :key="item.defaultUrl"
                      :class="[item.name, data.textFont.fontStyle === item.name && 'active-font']"
                      @click="data.textFont.fontStyle = item.name"
                      :style="getBackground(item.name)">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-collapse-item>
          <!-- 标题 -->
          <el-collapse-item name="3" v-if="collapses.includes('3')">
            <template slot="title">标题<i :class="getClass('3')"></i></template>
            <div class="label-title border-style">
              <div class="title">字体</div>
              <div class="content flex-container line-container">
                <el-color-picker v-model="data.titleFont.font.color" class="custom-el-color-picker" :color-format="'rgb'"></el-color-picker>
                <input-number v-model="data.titleFont.font.size" :suffix="'px'"></input-number>
                <el-select class="border-select custom-el-select" v-model="data.titleFont.font.family" clearable>
                  <!-- 宋体、楷体、黑体、微软雅黑 -->
                  <el-option label="宋体" value="宋体"></el-option>
                  <el-option label="楷体" value="楷体"></el-option>
                  <el-option label="黑体" value="黑体"></el-option>
                  <el-option label="微软雅黑" value="微软雅黑"></el-option>
                </el-select>
              </div>
              <div class="font-style flex-container line-container">
                <div class="left title">字体样式</div>
                <div class="right">
                  <div class="font-style-select">
                    <div
                      v-for="item in fontStyleImg"
                      :key="item.defaultUrl"
                      :class="[item.name, data.titleFont.fontStyle === item.name && 'active-font']"
                      @click="data.titleFont.fontStyle = item.name"
                      :style="getBackground(item.name)">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-collapse-item>
          <!-- 正文字体 -->
          <el-collapse-item name="4" v-if="collapses.includes('4')">
            <template slot="title">正文字体<i :class="getClass('4')"></i></template>
            <div class="label-title border-style">
              <div class="title">字体</div>
              <div class="content flex-container line-container">
                <el-color-picker v-model="data.textStyle.font.color" class="custom-el-color-picker" :color-format="'rgb'"></el-color-picker>
                <input-number v-model="data.textStyle.font.size" :suffix="'px'"></input-number>
                <el-select class="border-select custom-el-select" v-model="data.textStyle.font.family" clearable>
                  <!-- 宋体、楷体、黑体、微软雅黑 -->
                  <el-option label="宋体" value="宋体"></el-option>
                  <el-option label="楷体" value="楷体"></el-option>
                  <el-option label="黑体" value="黑体"></el-option>
                  <el-option label="微软雅黑" value="微软雅黑"></el-option>
                </el-select>
              </div>
              <div class="font-style flex-container line-container">
                <div class="left title">字体样式</div>
                <div class="right">
                  <div class="font-style-select">
                    <div
                      v-for="item in fontStyleImg"
                      :key="item.defaultUrl"
                      :class="[item.name, data.textStyle.fontStyle === item.name && 'active-font']"
                      @click="data.textStyle.fontStyle = item.name"
                      :style="getBackground(item.name)">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-collapse-item>
          <!-- 行表头字体 -->
          <el-collapse-item name="5" v-if="collapses.includes('5')">
            <template slot="title">行表头字体<i :class="getClass('5')"></i></template>
            <div class="label-title border-style">
              <div class="title">字体</div>
              <div class="content flex-container line-container">
                <el-color-picker v-model="data.headerFont.font.color" class="custom-el-color-picker" :color-format="'rgb'"></el-color-picker>
                <input-number v-model="data.headerFont.font.size" :suffix="'px'"></input-number>
                <el-select class="border-select custom-el-select" v-model="data.headerFont.font.family" clearable>
                  <!-- 宋体、楷体、黑体、微软雅黑 -->
                  <el-option label="宋体" value="宋体"></el-option>
                  <el-option label="楷体" value="楷体"></el-option>
                  <el-option label="黑体" value="黑体"></el-option>
                  <el-option label="微软雅黑" value="微软雅黑"></el-option>
                </el-select>
              </div>
              <div class="font-style flex-container line-container">
                <div class="left title">字体样式</div>
                <div class="right">
                  <div class="font-style-select">
                    <div
                      v-for="item in fontStyleImg"
                      :key="item.defaultUrl"
                      :class="[item.name, data.headerFont.fontStyle === item.name && 'active-font']"
                      @click="data.headerFont.fontStyle = item.name"
                      :style="getBackground(item.name)">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-collapse-item>
          <!-- 行表头背景 -->
          <el-collapse-item name="6" v-if="collapses.includes('6')">
            <template slot="title">行表头背景<i :class="getClass('6')"></i></template>
            <el-form-item label="背景颜色">
              <div class="form-item-right">
                <el-color-picker v-model="data.headerBackground.backgroundColor"
                                 class="custom-el-color-picker"
                                 :color-format="'rgb'"></el-color-picker>
              </div>
            </el-form-item>
            <div class="label-title flex-container line-container">
              <div class="left title">透明度</div>
              <div class="right">
                <input-number v-model="data.headerBackground.opacity" :suffix="'%'"></input-number>
              </div>
            </div>
          </el-collapse-item>
          <!-- 行内分割线 -->
          <el-collapse-item name="7" v-if="collapses.includes('7')" class="line-cut-line">
            <template slot="title">行内分割线<i :class="getClass('7')"></i></template>
            <div class="label-title border-style">
              <div class="content flex-container line-container">
                <el-color-picker v-model="data.LineDivider.color" class="custom-el-color-picker" :color-format="'rgb'"></el-color-picker>
                <input-number v-model="data.LineDivider.width" :suffix="'px'"></input-number>
                <el-select class="border-select custom-el-select" v-model="data.LineDivider.style" clearable>
                  <el-option class="border-select-option" label="实线" value="solid">
                    实线<span class="solid"></span>
                  </el-option>
                  <el-option class="border-select-option" label="虚线" value="dashed">
                    虚线<span class="dashed"></span>
                  </el-option>
                  <el-option class="border-select-option" label="点线" value="dotted">
                    点线<span class="dotted"></span>
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-collapse-item>
          <!-- 备注字体 -->
          <el-collapse-item name="8" v-if="collapses.includes('8')">
            <template slot="title">备注字体<i :class="getClass('8')"></i></template>
            <div class="label-title border-style">
              <div class="title">字体</div>
              <div class="content flex-container line-container">
                <el-color-picker v-model="data.remakeFont.font.color" class="custom-el-color-picker" :color-format="'rgb'"></el-color-picker>
                <input-number v-model="data.remakeFont.font.size" :suffix="'px'"></input-number>
                <el-select class="border-select custom-el-select" v-model="data.remakeFont.font.family" clearable>
                  <!-- 宋体、楷体、黑体、微软雅黑 -->
                  <el-option label="宋体" value="宋体"></el-option>
                  <el-option label="楷体" value="楷体"></el-option>
                  <el-option label="黑体" value="黑体"></el-option>
                  <el-option label="微软雅黑" value="微软雅黑"></el-option>
                </el-select>
              </div>
              <div class="font-style flex-container line-container">
                <div class="left title">字体样式</div>
                <div class="right">
                  <div class="font-style-select">
                    <div
                      v-for="item in fontStyleImg"
                      :key="item.defaultUrl"
                      :class="[item.name, data.remakeFont.fontStyle === item.name && 'active-font']"
                      @click="data.remakeFont.fontStyle = item.name"
                      :style="getBackground(item.name)">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-collapse-item>
          <!-- 数字字体 -->
          <el-collapse-item name="9" v-if="collapses.includes('9')">
            <template slot="title">数字字体<i :class="getClass('9')"></i></template>
            <div class="label-title border-style">
              <div class="title">字体</div>
              <div class="content flex-container line-container">
                <el-color-picker v-model="data.numberFont.font.color" class="custom-el-color-picker" :color-format="'rgb'"></el-color-picker>
                <input-number v-model="data.numberFont.font.size" :suffix="'px'"></input-number>
                <el-select class="border-select custom-el-select" v-model="data.numberFont.font.family" clearable>
                  <!-- 宋体、楷体、黑体、微软雅黑 -->
                  <el-option label="宋体" value="宋体"></el-option>
                  <el-option label="楷体" value="楷体"></el-option>
                  <el-option label="黑体" value="黑体"></el-option>
                  <el-option label="微软雅黑" value="微软雅黑"></el-option>
                </el-select>
              </div>
              <div class="font-style flex-container line-container">
                <div class="left title">字体样式</div>
                <div class="right">
                  <div class="font-style-select">
                    <div
                      v-for="item in fontStyleImg"
                      :key="item.defaultUrl"
                      :class="[item.name, data.numberFont.fontStyle === item.name && 'active-font']"
                      @click="data.numberFont.fontStyle = item.name"
                      :style="getBackground(item.name)">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-collapse-item>
          <!-- 图表字体 -->
          <el-collapse-item name="10" v-if="collapses.includes('10')">
            <template slot="title">图表字体<i :class="getClass('10')"></i></template>
            <div class="label-title border-style">
              <div class="title">字体</div>
              <div class="content flex-container line-container">
                <el-color-picker v-model="data.chartFont.font.color" class="custom-el-color-picker" :color-format="'rgb'"></el-color-picker>
                <input-number v-model="data.chartFont.font.size" :suffix="'px'"></input-number>
                <el-select class="border-select custom-el-select" v-model="data.chartFont.font.family" clearable>
                  <!-- 宋体、楷体、黑体、微软雅黑 -->
                  <el-option label="宋体" value="宋体"></el-option>
                  <el-option label="楷体" value="楷体"></el-option>
                  <el-option label="黑体" value="黑体"></el-option>
                  <el-option label="微软雅黑" value="微软雅黑"></el-option>
                </el-select>
              </div>
              <div class="font-style flex-container line-container">
                <div class="left title">字体样式</div>
                <div class="right">
                  <div class="font-style-select">
                    <div
                      v-for="item in fontStyleImg"
                      :key="item.defaultUrl"
                      :class="[item.name, data.chartFont.fontStyle === item.name && 'active-font']"
                      @click="data.chartFont.fontStyle = item.name"
                      :style="getBackground(item.name)">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-collapse-item>
          <!-- 柱状图 表内分割线 -->
          <!-- 表内分割线 -->
          <el-collapse-item name="11" v-if="collapses.includes('11')" class="line-cut-line">
            <template slot="title">表内分割线<i :class="getClass('11')"></i></template>
            <div class="label-title border-style">
              <div class="content flex-container line-container">
                <el-color-picker v-model="data.tableDivider.color" class="custom-el-color-picker" :color-format="'rgb'"></el-color-picker>
                <input-number v-model="data.tableDivider.width" :suffix="'px'"></input-number>
                <el-select class="border-select custom-el-select" v-model="data.tableDivider.style" clearable>
                  <el-option class="border-select-option" label="实线" value="solid">
                    实线<span class="solid"></span>
                  </el-option>
                  <el-option class="border-select-option" label="虚线" value="dashed">
                    虚线<span class="dashed"></span>
                  </el-option>
                  <el-option class="border-select-option" label="点线" value="dotted">
                    点线<span class="dotted"></span>
                  </el-option>
                </el-select>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item name="12" v-if="collapses.includes('12')">
            <template slot="title">柱形颜色<i :class="getClass('12')"></i></template>
            <div class="label-title border-style">
              <div class="content flex-container line-container">
                <el-color-picker v-model="data.columnColor.color" class="custom-el-color-picker"  @change="columnColorChange"></el-color-picker>
                <el-select class="border-select custom-el-select column-color-select" v-model="data.columnColor.color" >
                  <el-option v-for="(item,index) in data.columnColor.colorList" class="column-color-dropdown"
                             :key = "index"
                             :label="item"
                             :value="item"
                  >{{item}} <i class="el-icon-close" @click.stop="deleteColor(index)"></i></el-option>
                </el-select>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-form>
    </div>
  </div>
</template>

<script>
/**
   * 1、背景和边框
   * 2、文本字体
   * 3、标题
   * 4、正文字体
   * 5、行表头字体
   * 6、行表头背景
   * 7、行内分割线
   * 8、备注字体
   * 9、数字字体
   * 10、图表字体
   * 11、表内分割线
   * */
import inputNumber from './input-number'

const fontStyleImg = [
  // 粗体
  {
    name: 'bold',
    defaultUrl: require('../assets/images/bold.png'),
    activeUrl: require('../assets/images/active-bold.png')
  },
  // 斜体
  {
    name: 'italic',
    defaultUrl: require('../assets/images/incline.png'),
    activeUrl: require('../assets/images/active-incline.png')
  },
  // 下划线
  {
    name: 'underline',
    defaultUrl: require('../assets/images/underline.png'),
    activeUrl: require('../assets/images/active-underline.png')
  },
  // 正常字体
  {
    name: 'normal',
    defaultUrl: require('../assets/images/double-underline.png'),
    activeUrl: require('../assets/images/active-double-underline.png')
  }
]
const borderStyleImg = [
  {name: '样式1', value: require('../assets/borderImages/01.png')},
  {name: '样式2', value: require('../assets/borderImages/02.png')},
  {name: '样式3', value: require('../assets/borderImages/03.png')},
  {name: '样式4', value: require('../assets/borderImages/04.png')}
]
export default {
  name: 'style-setting',
  props: {
    collapses: {
      type: Array,
      required: true
    },
    data: {
      type: Object,
      default: () => {
      },
      required: true
    },
    defaultOpen: {
      default: true,
      type: Boolean
    }
  },
  data () {
    return {
      activeName: [],
      value: '',
      fontStyle: '',
      fontStyleImg,
      borderStyleImg
    }
  },
  components: {inputNumber},
  computed: {
    getClass () {
      return name => this.activeName.indexOf(name) > -1 ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
    },
    getBackground () {
      return type => {
        let img = this.fontStyleImg.find(c => c.name === type)
        // 判断是否选了字体样式
        if (this.fontStyle) {
          if (img) {
            return {'background-image': `url(${this.fontStyle === type ? img.activeUrl : img.defaultUrl})`}
          }
        } else {
          return {'background-image': `url(${img.defaultUrl})`}
        }
      }
    }
  },
  methods: {
    recoverSetting () {
      this.$emit('recoverSetting')
    },
    columnColorChange (a) {
      this.data.columnColor.colorList.push(a)
    },
    deleteColor (index) {
      this.data.columnColor.colorList.splice(index, 1)
    }
  },
  created () {
    if (this.defaultOpen) {
      // 默认打开第一个
      this.activeName = this.collapses[0]
    }
  },
  watch: {
    collapses: {
      handler (val) {
        if (val && val.length && this.defaultOpen) {
          // 切换的时候默认展开一个，不记录其他展开项
          this.activeName = [val[0]]
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
  .style-setting-container {
    width: 100%;
    height: 100%;
    @mixin setHeight($height) {
      height: $height;
      line-height: $height;
    }

    .flex-container {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left, .right {
        font-size: 12px;
        color: #1A1A1A;
      }
    }

    .line-container {
      @include setHeight(37px);
    }

    .custom-el-color-picker {
      height: 24px;
      width: 35px;

      .el-color-picker__trigger {
        border-color: #C2C3C4;
        @include setHeight(24px);
        width: 35px;
      }
    }

    .custom-el-select {
      @include setHeight(24px);

      .el-input__suffix {
        @include setHeight(24px);

        .el-input__suffix-inner {
          .el-input__icon {
            line-height: 24px;
          }
        }
      }

      .el-input {
        @include setHeight(24px);

        .el-input__inner {
          @include setHeight(24px);
          padding-left: 10px;
        }
      }
    }

    .style-setting-content {
      height: 100%;
      width: 100%;

      & > .title {
        padding-bottom: 5px;

        & > .left {
          font-size: 14px;
          color: #1A1A1A;
        }

        & > .right {
          .el-button {
            span {
              font-size: 12px;
            }

            .fa-undo {
              transform: scale(-1, 1);
            }
          }
        }
      }

      .el-collapse {
        border: none;

        .el-collapse-item {
          .el-collapse-item__header {
            color: #1A1A1A;
            @include setHeight(28px);
            font-size: 12px;
            position: relative;

            &:hover, &:active, &:focus {
              color: #1A1A1A;
            }

            .el-collapse-item__arrow {
              display: none;
            }

            .el-icon-arrow-down, .el-icon-arrow-up {
              position: absolute;
              right: 0;
            }
          }

          .el-collapse-item__wrap {
            border: none;
          }

          & > div > .is-active {
            border-bottom: 1px solid #EBEEF5;
          }

          .el-collapse-item__content {
            padding: 12px 0;

            .el-form-item {
              margin-bottom: 0;

              .el-form-item__label {
                font-size: 12px;
                color: #1A1A1A;
              }

              .form-item-right {
                text-align: right;
              }
            }

            .label-title {
              font-size: 12px;
              color: #1A1A1A;

              .right {
                width: 56px;
              }

              .title {
                font-size: 12px;
                color: #1A1A1A;
              }
            }

            .border-style {
              & > .content {
                .input-number-container {
                  @include setHeight(24px);
                  margin-bottom: 2px;
                  width: 70px;
                }

                .border-select {
                  width: 80px;
                }
                .column-color-select {
                  width: 140px;
                }
              }
            }

            .border-style-img {
              .border-style-img-select {
                width: 106px;
              }
            }

            .font-style {
              & > .right {
                width: 123px;

                .font-style-select {
                  width: 123px;
                  @include setHeight(24px);
                  background: #FFFFFF;
                  border: 1px solid #C2C3C4;
                  border-radius: 4px;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;

                  & > div {
                    flex: 1;
                    border-right: 1px solid #ECECEC;
                    height: 100%;
                    cursor: pointer;
                    background-repeat: no-repeat;
                    background-position: center;

                    &:last-child {
                      border: none;
                    }

                    &:hover {
                      background-color: #E3F1FE;
                    }
                  }

                  .active-font {
                    background-color: #E3F1FE;
                  }
                }
              }
            }
          }
        }

        .line-cut-line {
          .el-collapse-item__wrap {
            .el-collapse-item__content {
              padding: 6px 0;
            }
          }
        }
      }
    }

    .decorate-opacity {
      & > .right {
        width: 50px;
      }
    }
  }

  .el-select-dropdown {
    .el-scrollbar {
      .el-select-dropdown__wrap {
        .el-scrollbar__view {
          .column-color-dropdown {
            padding: 0 0 0 10px;
            i{
              position: absolute;
              right: 2px;
              top: 10px;
            }
          }
          .border-select-option {
            padding: 0 8px;

            & > span {
              width: 25px;
              display: inline-block;
              border-bottom: 1px solid #606266;
              margin-left: 10px;
              margin-bottom: 4px;
            }

            & > .dashed {
              border-bottom: 1px dashed #606266;
            }

            & > .dotted {
              border-bottom: 1px dotted #606266;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/design/customPage/style-setting/style-setting.vue